query CorporateWorkgroup($id: UUID!) {
  corporateWorkgroup(id: $id) {
    id
    _rowTimestamp
    _isUpdatable
    _isDeletable
    workgroupNumber
    name
    description
    businessUnitId
    corporateChartOfAccount {
      id
    }
    productionStatusTypeId
    productionPhaseId
    isNewWorkgroupSelectable
    prefixCode
    statusType {
      statusType
    }
       workgroupUsersByWorkgroupId(orderBy: USER_PROFILE_BY_USER_PROFILE_ID__NAME_ASC) {
        nodes {
          id
          _rowTimestamp
          userProfileId
          _isUpdatable
          _isDeletable
          userProfile {
            name
            emailAccount
            _signinInfo {
              profileIconState
              profileIconType
            }
            _lastUsedDate
          }
        }
      }
   workgroupCurrenciesByWorkgroupId(orderBy: NAME_ASC) {
    nodes {
     id
     _rowTimestamp
     name
     currencyId
     exchangeRate
     spotRate
     isSpotRatePreferred
     _isActive
     _isDeletable
     _isUpdatable

    }
   }
  }
}
